<template>
    <DataTable
        :fields="fields"
        :items="items"
        stacked="md"
        :loading="parentComponent.loading"
        :error="parentComponent.error"
        :pagination="false"
    >
        <template #cell(action)="{item}">
            <div class="d-flex gap-2 justify-content-end">
                <ButtonIcon size="sm" variant="success" :disabled="isDeleting(item.id)" :to="{ name: 'WidgetGenerator', query: { space: item.space.id, buybox: item.id } }">{{ $t('generateWidget') }}</ButtonIcon>
                <ButtonIcon size="sm" variant="primary" :disabled="isDeleting(item.id)" :to="{ name: 'WidgetSettingsEditTab', params: { id: item.id, tab: 'campaigns' } }">{{ $t('manageStores') }}</ButtonIcon>
                <ButtonIcon size="sm" variant="primary" :disabled="isDeleting(item.id)" :to="{ name: 'WidgetSettingsEditTab', params: { id: item.id, tab: 'appearance' } }">{{ $t('editAppearance') }}</ButtonIcon>
                <ButtonIcon size="sm" icon="trash-2" variant="danger" :loading="isDeleting(item.id)" @click="deleteItem(item)" />
            </div>
        </template>
        <template #afterTable>
            <ButtonIcon icon="plus" class="mr-auto mt-3" @click="parentComponent.addConfiguration()">{{ $t('addConfiguration') }}</ButtonIcon>
        </template>
    </DataTable>
</template>



<script>
    import DataTable from '@/components/common/DataTable.vue';

    export default {
        name: 'Results',
        components: {
            DataTable,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                requestBuyboxes: this.$req('buyboxes/buyboxes'),
            };
        },
        computed: {
            fields() {
                return [
                    { key: 'id', label: this.$t('id'), sortable: true },
                    { key: 'name', label: this.$t('configurationName'), sortable: true },
                    { key: 'space.name', label: this.$t('space'), sortable: true },
                    { key: 'campaignCount', label: this.$t('numberOfStoresAdded'), sortable: true },
                    { key: 'action', label: '', tdClass: 'text-right', thClass: 'text-right' },
                ];
            },
            items() {
                const spaceId = this.parentComponent.filtersParams.space;
                if (spaceId) return this.parentComponent.items.filter(item => item.space.id === spaceId);
                return this.parentComponent.items;
            },
        },
        methods: {
            deleteItem(item) {
                const text = this.$createElement('div', { domProps: { innerHTML: this.$t('areYouSureYouWantToDeleteThisConfiguration', { name: item.name }) } });
                this.$bvModal
                    .msgBoxConfirm(text, {
                        title: this.$t('confirmationOfConfigurationRemoval'),
                        okTitle: this.$t('delete'),
                        cancelTitle: this.$t('cancel'),
                        cancelVariant: 'light',
                        okVariant: 'danger',
                        hideHeaderClose: false,
                    })
                    .then(value => {
                        if (value) {
                            this.requestBuyboxes
                                .id(`delete-${item.id}`)
                                .delete({ urlParams: { id: item.id } })
                                .then(() => {
                                    this.parentComponent.fetchData();
                                    this.$toastr.success(this.$t('buyboxRemovedSuccessfully'));
                                })
                                .catch(error => this.$toastr.error(error.message, this.$t('errorOccurred')));
                        }
                    });
            },
            isDeleting(id) {
                return this.requestBuyboxes.getLoading(`delete-${id}`);
            },
        },
    };
</script>
